/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconArrowLeft8 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowLeft8(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 8 8" ref={ref}>
            <path
                d="M3.31 3.975 5.903 6.57a.75.75 0 0 1-1.061 1.06L1.719 4.505a.75.75 0 0 1 0-1.06L4.842.32a.75.75 0 1 1 1.06 1.06L3.31 3.975Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconArrowLeft12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowLeft12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path
                d="M4.81 5.975 8.403 9.57a.75.75 0 1 1-1.061 1.06L3.219 6.505a.75.75 0 0 1 0-1.06L7.342 1.32a.75.75 0 1 1 1.06 1.06L4.81 5.975Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconArrowLeft16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowLeft16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                d="m6.414 8 4.79 4.793a1 1 0 1 1-1.415 1.414l-5.496-5.5a1 1 0 0 1 0-1.414l5.496-5.5a1 1 0 0 1 1.415 1.414L6.414 8Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconArrowLeft20 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowLeft20(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 20 20" ref={ref}>
            <path
                d="M13.5 15.293a1 1 0 0 1-1.414 1.414l-5.647-5.646a1.5 1.5 0 0 1 0-2.122l5.647-5.646A1 1 0 1 1 13.5 4.707L8.207 10l5.293 5.293Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconArrowLeft24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowLeft24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                d="M15.5 18.293a1 1 0 0 1-1.414 1.414l-6.647-6.646a1.5 1.5 0 0 1 0-2.122l6.647-6.646A1 1 0 1 1 15.5 5.707L9.207 12l6.293 6.293Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconArrowLeft = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowLeft(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '8':
            return <IconArrowLeft8 {...iconProps} />;
        case '12':
            return <IconArrowLeft12 {...iconProps} />;
        case '16':
            return <IconArrowLeft16 {...iconProps} />;
        case '20':
            return <IconArrowLeft20 {...iconProps} />;
        case '24':
            return <IconArrowLeft24 {...iconProps} />;
        default:
            return <IconArrowLeft24 {...iconProps} />;
    }
});
